import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const ExpensePage = lazy(() => import("@/pages/ExpenseCategory/ExpensePage"));
const ExpenseCategory = lazy(() => import("@/pages/ExpenseCategory/ExpenseCategory"));
const ExpenseSetting = lazy(() => import("@/pages/ExpenseSetting/ExpenseSetting"));
const ExpenseSetApprovers = lazy(() => import("@/pages/ExpenseSetApprovers/ExpenseSetApprovers"));

const ExpenseRoute: RouteConfig = {
    path: "expense",
    pageName: "Expense",
    sidebar: { show: true, icon: "" },
    permission: ["ExpenseSettings"],
    element: <ExpensePage />,
    children: {
        Expense_Setting: {
            path: "expense_setting",
            pageName: "Expense Setting",
            sidebar: { show: true, icon: "" },
            element: <ExpenseSetting />
        },
        Set_Approvers: {
            path: "set_approvers",
            pageName: "Set Approvers",
            sidebar: { show: true, icon: "" },
            element: <ExpenseSetApprovers />
        },
        Expense_Category: {
            path: "expense_category",
            pageName: "Expense Category",
            sidebar: { show: true, icon: "" },
            element: <ExpenseCategory />
        }
    }
}

export default ExpenseRoute;